import React, { useEffect, useState } from "react";
import Layout from "Reusable/Tutor/Layout";
import DashboardClass from "./dashboard.module.css";
import { FaRupeeSign } from "react-icons/fa";
import Loader from "Reusable/Common/LoadingComponents/loader/loader";
import { Services } from "Service/service";
import { useForm, SubmitHandler } from "react-hook-form";
import Moment from "react-moment";
import { resetState } from "sweetalert/typings/modules/state";
import { warningSwal } from "Reusable/utils/Toast";
import moment from "moment";
import { IoStar } from "react-icons/io5";

type Inputs = {
    Earning_SummaryType: string;
    FromDate: string;
    ToDate: string;
};
function Dashboard() {
    const [upcomingClasses, setUpcomingClasses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [earning, setEarning] = useState({ NeedToPay: 0, Earnings: 0 });
    const [userData, setUserData] = useState<any>(null);
    const token = {
        Authorization: `token ${localStorage.getItem("learn2readToken")}`,
    };
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: {},
    } = useForm<Inputs>();

    useEffect(() => {
        const fetchData = async () => {
            try {
                let body = JSON.stringify({ Earning_SummaryType: "ThisWeek" });
                const [classes, summaryData] = await Promise.all([
                    Services.get_dashboard_class("GET", null, token),
                    Services.get_earning_class("POST", body, token),
                ]);
                if (classes?.Status === 1) {
                    setUpcomingClasses(classes.UpcommingClasses);
                }
                if (summaryData.Status === 1) {
                    setEarning({
                        Earnings:
                            summaryData.Earnings != null
                                ? summaryData.Earnings
                                : 0,
                        NeedToPay:
                            summaryData.NeedToPay != null
                                ? summaryData.NeedToPay
                                : 0,
                    });
                }

                setLoading(false);
            } catch {
                setLoading(false);
                alert("something went wrong try again");
            }
        };

        fetchData();
    }, []);
    console.log(earning);
    const formData = watch();

    // load LoginDetails into state and keep sync across tabs
    useEffect(() => {
        const load = () => {
            const raw = localStorage.getItem("LoginDetails");
            if (raw) {
                try {
                    setUserData(JSON.parse(raw));
                } catch (e) {
                    setUserData(null);
                }
            } else {
                setUserData(null);
            }
        };
        load();
        const onStorage = (e: StorageEvent) => {
            if (e.key === "LoginDetails") load();
        };
        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);

    // derive stats and format them: show 'NA' when value is 0/null/undefined/'na' or empty
    const profileRatingRaw =
        userData?.rating ??
        userData?.Rating ??
        userData?.profile?.rating ??
        null;
    const totalReviewsRaw =
        userData?.totalReviews ??
        userData?.TotalReviews ??
        userData?.profile?.totalReviews ??
        null;
    const uniqueStudentsRaw =
        userData?.uniqueStudentsReviewed ??
        userData?.UniqueStudentsReviewed ??
        userData?.profile?.uniqueStudentsReviewed ??
        null;

    const formatStat = (v: any) => {
        if (v === null || v === undefined) return "NA";
        if (typeof v === "string") {
            const s = v.trim().toLowerCase();
            if (s === "" || s === "na") return "NA";
            const n = Number(v);
            if (!isNaN(n) && n === 0) return "NA";
            return v;
        }
        if (typeof v === "number") {
            if (v === 0) return "NA";
            return v;
        }
        return "NA";
    };

    const totalReviewsDisplayRaw = formatStat(totalReviewsRaw);
    const uniqueStudentsDisplayRaw = formatStat(uniqueStudentsRaw);
    // normalize to string and ensure 'NA' is shown for zero/empty
    const totalReviewsDisplay =
        typeof totalReviewsDisplayRaw === "number"
            ? String(totalReviewsDisplayRaw)
            : totalReviewsDisplayRaw ?? "NA";
    const uniqueStudentsDisplay =
        typeof uniqueStudentsDisplayRaw === "number"
            ? String(uniqueStudentsDisplayRaw)
            : uniqueStudentsDisplayRaw ?? "NA";
    const ratingDisplay = (() => {
        const r = profileRatingRaw;
        if (r === null || r === undefined) return 0;
        if (typeof r === "string") {
            const s = r.trim().toLowerCase();
            if (s === "" || s === "na") return 0;
            const n = Number(r);
            if (!isNaN(n) && n === 0) return 0;
            return Number(n);
        }
        if (typeof r === "number") {
            if (r === 0) return 0;
            return r;
        }
        return 0;
    })();

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (data.Earning_SummaryType == "ByDate") {
            if (moment(data.FromDate).isAfter(data.ToDate)) {
                warningSwal("Warning", "Invalid Date range");
                return;
            }
        }
        console.log("1");
        setLoading(true);
        try {
            let body = JSON.stringify({ ...data });
            const [summaryData] = await Promise.all([
                Services.get_earning_class("POST", body, token),
            ]);

            if (summaryData.Status === 1) {
                if (summaryData.Earnings != null) {
                    setEarning({
                        Earnings:
                            summaryData.Earnings != null
                                ? summaryData.Earnings
                                : 0,
                        NeedToPay:
                            summaryData.NeedToPay != null
                                ? summaryData.NeedToPay
                                : 0,
                    });
                }
            }

            setLoading(false);
        } catch {
            setLoading(false);
            alert("something went wrong try again");
        }
    };

    const changeHandler = (e: any) => {
        let value = e.target.value;
        setValue("FromDate", "");
        setValue("ToDate", "");
        if (value != "ByDate") {
            handleSubmit(onSubmit)();
        }
    };

    return (
        <Layout Active={"Dashboard"}>
            {loading && <Loader />}
            <div className={DashboardClass["Container"]}>
                <div className={DashboardClass["wrapper"]}>
                    <header>
                        <div>
                            <h3>
                                {" "}
                                Hi,
                                {`${
                                    userData?.FirstName
                                        ? userData?.FirstName
                                        : "Tutor"
                                } ${
                                    userData?.LastName ? userData?.LastName : ""
                                }`}
                            </h3>
                            <p>
                                Welcome to Dashboard here you find overview of
                                you work
                            </p>
                        </div>
                        <div>
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            fontSize: "20px",
                                            lineHeight: "1",
                                        }}>
                                        {/* Gray stars (background) */}
                                        <div style={{ color: "lightgray" }}>
                                            {Array.from(
                                                { length: 5 },
                                                (_, index) => (
                                                    <IoStar key={index} />
                                                )
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                color: "gold",
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: `${
                                                    (ratingDisplay / 5) * 100
                                                }%`,
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                            }}>
                                            {Array.from(
                                                { length: 5 },
                                                (_, index) => (
                                                    <IoStar key={index} />
                                                )
                                            )}
                                        </div>
                                    </div>
                                    <p
                                        style={{
                                            fontSize: "16px",
                                            color: "black",
                                        }}>
                                        {ratingDisplay != 0
                                            ? ratingDisplay
                                            : "NA"}
                                    </p>
                                </div>
                                <p style={{ fontSize: "13px" }}>
                                    Total Reviews:{totalReviewsDisplay}
                                </p>
                                <p style={{ fontSize: "13px" }}>
                                    Unique Students : {uniqueStudentsDisplay}
                                </p>
                            </div>
                            <form
                                className={DashboardClass["filter"]}
                                onSubmit={handleSubmit(onSubmit)}>
                                <select
                                    {...register("Earning_SummaryType", {
                                        required: true,
                                        onChange: (e) => changeHandler(e),
                                    })}>
                                    <option value="ThisWeek">This Week</option>
                                    <option value="ThisMonth">
                                        This Month
                                    </option>
                                    <option value="ByDate">By Date</option>
                                </select>
                                {formData?.Earning_SummaryType === "ByDate" && (
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="From Date"
                                            {...register("FromDate", {
                                                required: true,
                                            })}
                                            onClick={(event) => {
                                                const inputElement =
                                                    event.target as HTMLInputElement;
                                                inputElement.type = "date";
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="To Date"
                                            {...register("ToDate", {
                                                required: true,
                                            })}
                                            onClick={(event) => {
                                                const inputElement =
                                                    event.target as HTMLInputElement;
                                                inputElement.type = "date";
                                            }}
                                        />
                                        <button>Submit</button>
                                    </div>
                                )}
                            </form>
                        </div>
                    </header>
                    <div className={DashboardClass["earnings"]}>
                        <div>
                            <p>You have been paid </p>
                            <h3>
                                <FaRupeeSign /> {Math.round(earning.Earnings)}
                            </h3>
                            <p>for work done</p>
                        </div>
                        <div>
                            <p>You have yet to be paid </p>
                            <h3>
                                <FaRupeeSign />
                                {Math.round(earning.NeedToPay)}
                            </h3>
                            <p>for work done</p>
                        </div>
                    </div>

                    <div className={DashboardClass["class-wrapper"]}>
                        <div className={DashboardClass["classes"]}>
                            <h3>Upcoming Classes</h3>
                            <div className={DashboardClass["classes"]}>
                                {upcomingClasses.length > 0 ? (
                                    <>
                                        {upcomingClasses.map((item: any) => (
                                            <div
                                                key={
                                                    item?.Id ||
                                                    item?.BatchId ||
                                                    item?.Scheduled_StartDate
                                                }
                                                className={
                                                    DashboardClass[
                                                        "class-details"
                                                    ]
                                                }>
                                                <h3>
                                                    {item?.BatchName} (
                                                    {item?.ClassLessonName})
                                                    <span
                                                        style={{
                                                            color: "gray",
                                                            fontSize: "0.8rem",
                                                            marginLeft: 8,
                                                        }}>
                                                        ({item?.Duration} min)
                                                    </span>
                                                </h3>
                                                <div>
                                                    <p>
                                                        <Moment format="DD-MM-YYYY">
                                                            {
                                                                new Date(
                                                                    item?.Scheduled_StartDate
                                                                )
                                                            }
                                                        </Moment>
                                                    </p>
                                                    <p>
                                                        {
                                                            item?.Scheduled_StartTime
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <h6>
                                        Here you can see upcoming classes, you
                                        have no upcoming class
                                    </h6>
                                )}
                            </div>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Dashboard;
